<template>
  <div class="push-container">
    <div v-for="(item, index) in tableColumn" :key="index" style="display: flex;">
      <div
        class="push-head"
        :style="{'border-bottom': index < tableColumn.length - 1 ? '1px solid #ccc' : ''}"
      >{{ item.label }}</div>
      <div style="flex: 1;padding: 10px" :style="{'border-bottom': index < tableColumn.length - 1 ? '1px solid #ccc' : ''}">
        <div v-if="item.prop === 'pushStatus'">
          <el-tag v-if="detailData.pushStatus === 0" size="mini" type="warning">
            {{ statusOptions[detailData.pushStatus].label }}
          </el-tag>
          <el-tag v-if="detailData.pushStatus === 1" size="mini" type="success">
            {{ statusOptions[detailData.pushStatus].label }}
          </el-tag>
          <el-tag v-if="detailData.pushStatus === 2" size="mini" type="danger">
            {{ statusOptions[detailData.pushStatus].label }}
          </el-tag>
          <el-tag v-if="detailData.pushStatus === 3" size="mini" type="info">
            {{ statusOptions[detailData.pushStatus].label }}
          </el-tag>
        </div>
        <div v-else-if="item.prop === 'currentMdfeStatus'">
          <el-tag v-if="detailData.currentMdfeStatus === 1" size="mini" type="success">
            {{ mdfeStatus[detailData.currentMdfeStatus].label }}
          </el-tag>
          <el-tag v-if="detailData.currentMdfeStatus === 2" size="mini" type="danger">
            {{ mdfeStatus[detailData.currentMdfeStatus].label }}
          </el-tag>
          <el-tag v-if="detailData.currentMdfeStatus === 3" size="mini" type="info">
            {{ mdfeStatus[detailData.currentMdfeStatus].label }}
          </el-tag>
        </div>
        <div v-else>
          {{ detailData[item.prop] }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Detail',
  props: {
    detailData: {
      type: Object,
      default: () => {}
    },
    statusOptions: {
      type: Object,
      default: () => {
        return {
          0: {
            label: this.$t('mdfeTranslate.PendingPush'), // '待推送',
            value: 0
          },
          1: {
            label: this.$t('mdfeTranslate.Pushed'), // '已推送',
            value: 1
          },
          2: {
            label: this.$t('mdfeTranslate.PushFailed'), // '推送失败',
            value: 2
          },
          3: {
            label: this.$t('mdfeTranslate.Canceled'), // '已取消',
            value: 3
          }
        };
      }
    },
    mdfeStatus: {
      type: Object,
      default: () => {
        return {
          1: {
            label: this.$t('mdfeTranslate.Authorized'),
            value: 1
          },
          2: {
            label: this.$t('collectionCenter.cancelled'),
            value: 2
          },
          3: {
            label: this.$t('mdfeTranslate.Closed'),
            value: 3
          }
        };
      }
    }
  },
  data() {
    return {
      tableColumn: [
        {
          label: this.$t('mdfeTranslate.MDFEKey'), // MDFE秘钥
          prop: 'mdfeKey',
          minWidth: 400
        },
        {
          label: this.$t('mdfeTranslate.CurrentStatusMDFe'), // MDFE状态
          prop: 'currentMdfeStatus',
          minWidth: 180
        },
        {
          label: this.$t('mdfeTranslate.Airline'), // 航空公司
          prop: 'airlineName',
          minWidth: 180
        },
        {
          label: this.$t('mdfeTranslate.Origin') + 'IATA', // 始发地
          prop: 'originIata',
          minWidth: 180
        },
        {
          label: this.$t('mdfeTranslate.destination') + 'IATA', // 目的地
          prop: 'destIata',
          minWidth: 180
        },
        {
          label: this.$t('mdfeTranslate.CTeQuantity'), // CTe数量
          prop: 'cteCount',
          minWidth: 180
        },
        {
          label: this.$t('mdfeTranslate.TotalWeight') + '（kg）', // 总重量
          prop: 'totalWeight',
          minWidth: 180
        },
        {
          label: this.$t('GlobalSetObj.pushStatus'), // 推送状态
          prop: 'pushStatus',
          minWidth: 160,
          align: 'center'
        },
        {
          label: this.$t('mdfeTranslate.AWBNumber'), // AWB号
          prop: 'airWaybillNumber',
          minWidth: 160,
          align: 'center'
        },
        {
          label: this.$t('mdfeTranslate.PushTime'), // 推送时间
          prop: 'pushTime',
          minWidth: 180
        },
        {
          label: this.$t('mdfeTranslate.Pusher'), // 推送人
          prop: 'operatorUserName',
          minWidth: 180
        }
      ]
    };
  },
  methods: {

  }
};
</script>

<style scoped>
.push-container {
  border: 1px solid #ccc;
  border-radius: 10px;
  overflow:hidden;
}
.push-head {
  width: 180px;
  background:#fafafa;
  padding: 10px;
  border-right: 1px solid #ccc;
}
</style>
